/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { Box } from '@mui/material';
import { type ReactNode, useState, useContext } from 'react';

import type { MainComponentProps } from '../../constants/tabs';
import { BuilderToggleButtons } from '../BuilderToggleButtons/BuilderToggleButtons';
import { CKEditor5Iframe } from '../CKEditor5Iframe/CKEditor5Iframe';
import { Snippets } from './Snippets/Snippets';
import { GTMContext } from '../../contexts/GTMContext';
import { GTM_EVENT_TOGGLE_PREVIEW } from '../../constants/GTMEventNames';

const builderToggleOptions = [
	{ type: 'snippets', name: 'Code snippets' },
	{ type: 'preview', name: 'Editor preview' }
];

export function SnippetsContainer( {
	previewLocation,
	locationOrigin
}: MainComponentProps ): ReactNode {
	const { triggerGTMEvent } = useContext( GTMContext );

	const [ builderToggleSelectedOption, setBuilderToggleSelectedOption ] = useState( 'snippets' );

	function handleTabChange( newValue: string ) {
		setBuilderToggleSelectedOption( newValue );

		triggerGTMEvent( {
			event: GTM_EVENT_TOGGLE_PREVIEW,
			stage: 'installation',
			action: newValue
		} );
	}

	const builderToggleButtonsNode = (
		<BuilderToggleButtons
			options={ builderToggleOptions }
			selectedOption={ builderToggleSelectedOption }
			onOptionChange={ handleTabChange }
		/>
	);

	return (
		<Box>
			{ builderToggleSelectedOption === 'snippets' ?
				<Snippets BuilderToggleButtons={ builderToggleButtonsNode }/> :
				<CKEditor5Iframe
					locationOrigin={ locationOrigin }
					previewLocation={ previewLocation }
					BuilderToggleButtons={ builderToggleButtonsNode }
				/>
			}
		</Box>
	);
}
